import Vue from 'vue'
import App from './App'
import router from './router'
import MetaInfo from 'vue-meta-info'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(MetaInfo)
var myEventVue = new Vue()

// 抛送事件
Vue.prototype.dispatch = function (ekey, param = null) {
  myEventVue.$emit(ekey, param)
}

// 注册事件
Vue.prototype.addEvent = function (ekey, handler) {
  myEventVue.$on(ekey, handler)
}

// 移出事件
Vue.prototype.removeEvent = function (ekey, handler) {
  myEventVue.$off(ekey, handler)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js